// Links de calendário (Google / .ics) para escritura ou CPCV, com convidados opcionais.
function slot(date, time) {
  const d = date.replace(/-/g, "");
  if (!time) {
    const n = new Date(`${date}T12:00:00`); n.setDate(n.getDate() + 1);
    const end = n.toISOString().slice(0, 10).replace(/-/g, "");
    return { google: `${d}/${end}`, ics: [`DTSTART;VALUE=DATE:${d}`, `DTEND;VALUE=DATE:${end}`] };
  }
  const [h, m] = time.split(":").map(Number);
  const t = (hh) => `${d}T${String(hh).padStart(2, "0")}${String(m || 0).padStart(2, "0")}00`;
  return { google: `${t(h)}/${t(h + 1)}`, ics: [`DTSTART;TZID=Europe/Lisbon:${t(h)}`, `DTEND;TZID=Europe/Lisbon:${t(h + 1)}`] };
}

export function calendarItems({ uid, title, date, time, place, guests = [], prefix = "cal" }) {
  const s = slot(date, time);
  const emails = guests.map((g) => g.email).filter(Boolean);
  const google = () => window.open(`https://calendar.google.com/calendar/render?action=TEMPLATE&text=${encodeURIComponent(title)}&dates=${s.google}&ctz=Europe/Lisbon${place ? `&location=${encodeURIComponent(place)}` : ""}${emails.length ? `&add=${encodeURIComponent(emails.join(","))}` : ""}`, "_blank", "noopener");
  const ics = () => {
    const att = guests.filter((g) => g.email).map((g) => `ATTENDEE;CN=${(g.name || g.email).replace(/[;,]/g, " ")};RSVP=TRUE:mailto:${g.email}`);
    const body = ["BEGIN:VCALENDAR", "VERSION:2.0", "PRODID:-//ImoDesk//PT", "METHOD:REQUEST", "BEGIN:VEVENT", `UID:${uid}@imodesk.pt`,
      `DTSTAMP:${new Date().toISOString().replace(/[-:]/g, "").slice(0, 15)}Z`, ...s.ics, `SUMMARY:${title}`, place ? `LOCATION:${place}` : null, ...att, "END:VEVENT", "END:VCALENDAR"].filter(Boolean).join("\r\n");
    const url = URL.createObjectURL(new Blob([body], { type: "text/calendar" }));
    const a = document.createElement("a"); a.href = url; a.download = `${uid}.ics`; a.click();
    URL.revokeObjectURL(url);
  };
  return [{ label: "Google Calendar", onClick: google, testid: `${prefix}-google` }, { label: "Outlook / iPhone (.ics)", onClick: ics, testid: `${prefix}-ics` }];
}
